/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  CertifiedPlantType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface DeleteDeviceInCertifiedPlantInput {
  plantId: string;
  deviceId: string;
}
const build = (_query: DocumentNode, input: DeleteDeviceInCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    deleteDeviceInCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class DeleteDeviceInCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: DeleteDeviceInCertifiedPlantInput): Promise<apollo.FetchResult< { deleteDeviceInCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ deleteDeviceInCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
